/**
 * Exposes jQuery as window.jQuery/window.$ for old-style jQuery plugins
 * (e.g. @fancyapps/fancybox) that expect a global rather than importing
 * jQuery themselves.
 *
 * This must be its own module (not a statement in site.js) and imported
 * before those plugins: ES module imports are hoisted, so a plain
 * `window.jQuery = $` statement in site.js's own body would run *after*
 * all of site.js's imports -- including the plugins it's meant to
 * precede -- have already executed.
 */
import $ from "jquery"

window.jQuery = window.$ = $

export default $
